import React from "react";
import { useHomeLayoutConfig } from "@/modules/homeDisplay/hooks";
import utils from "@/utils";
import { SKIN_ICON_DEFAULTS, SKIN_IMAGE_DEFAULT_URLS } from "./defaults";
import type { SkinIconKey } from "./skinIconKeys";

/** 后台「首页布局配置 → 皮肤图标」给了这枚图标就返回其可用 URL，否则 undefined（用内置默认） */
export const useSkinIconSrc = (name: SkinIconKey): string | undefined => {
  const raw = useHomeLayoutConfig()?.skinIcons?.[name];
  const v = typeof raw === "string" ? raw.trim() : "";
  return v ? utils.getImageUrl(v) : undefined;
};

/** 底图类键：后台配了图 → 其 URL，否则皮肤内置默认 PNG 的 URL（给 CSS background-image / <img src> 用） */
export const useSkinImageSrc = (name: SkinIconKey): string | undefined =>
  useSkinIconSrc(name) ?? SKIN_IMAGE_DEFAULT_URLS[name];

export interface SkinIconProps {
  name: SkinIconKey;
  className?: string;
}

/**
 * 可配置皮肤图标：后台配了图 → <img>；没配 → 内置 currentColor SVG。
 * 两种形态都吃同一个 className，使用处只管尺寸 / 颜色。
 */
export const SkinIcon: React.FC<SkinIconProps> = ({ name, className }) => {
  const src = useSkinIconSrc(name);
  if (src) {
    return (
      <img
        className={className}
        src={src}
        alt=""
        draggable={false}
        aria-hidden="true"
      />
    );
  }
  const Default = SKIN_ICON_DEFAULTS[name];
  return <Default className={className} />;
};
